import { createFileRoute } from '@tanstack/react-router'

import { AiTextsScreen } from './-components/ai-texts-screen.tsx'

export const Route = createFileRoute('/reports/ai-texts')({
  component: AiTextsScreen
})
